@file:OptIn(InternalResourceApi::class)

package heyagenda.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/heyagenda.shared.generated.resources/"

@delegate:ResourceContentHash(1_869_336_776)
internal val Res.drawable.hourglass_simple_medium: DrawableResource by lazy {
      DrawableResource("drawable:hourglass_simple_medium", setOf(
        ResourceItem(setOf(), "${MD}drawable/hourglass_simple_medium.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_981_223_359)
internal val Res.drawable.house: DrawableResource by lazy {
      DrawableResource("drawable:house", setOf(
        ResourceItem(setOf(), "${MD}drawable/house.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(688_223_744)
internal val Res.drawable.house_line: DrawableResource by lazy {
      DrawableResource("drawable:house_line", setOf(
        ResourceItem(setOf(), "${MD}drawable/house_line.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_754_910_486)
internal val Res.drawable.house_simple: DrawableResource by lazy {
      DrawableResource("drawable:house_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/house_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-346_932_773)
internal val Res.drawable.hurricane: DrawableResource by lazy {
      DrawableResource("drawable:hurricane", setOf(
        ResourceItem(setOf(), "${MD}drawable/hurricane.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_586_889_185)
internal val Res.drawable.ice_cream: DrawableResource by lazy {
      DrawableResource("drawable:ice_cream", setOf(
        ResourceItem(setOf(), "${MD}drawable/ice_cream.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(434_733_914)
internal val Res.drawable.identification_badge: DrawableResource by lazy {
      DrawableResource("drawable:identification_badge", setOf(
        ResourceItem(setOf(), "${MD}drawable/identification_badge.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-17_537_798)
internal val Res.drawable.identification_card: DrawableResource by lazy {
      DrawableResource("drawable:identification_card", setOf(
        ResourceItem(setOf(), "${MD}drawable/identification_card.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-182_884_436)
internal val Res.drawable.image: DrawableResource by lazy {
      DrawableResource("drawable:image", setOf(
        ResourceItem(setOf(), "${MD}drawable/image.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_655_229_092)
internal val Res.drawable.image_broken: DrawableResource by lazy {
      DrawableResource("drawable:image_broken", setOf(
        ResourceItem(setOf(), "${MD}drawable/image_broken.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_128_001_415)
internal val Res.drawable.images: DrawableResource by lazy {
      DrawableResource("drawable:images", setOf(
        ResourceItem(setOf(), "${MD}drawable/images.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_942_147_169)
internal val Res.drawable.infinity: DrawableResource by lazy {
      DrawableResource("drawable:infinity", setOf(
        ResourceItem(setOf(), "${MD}drawable/infinity.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(27_309_483)
internal val Res.drawable.info: DrawableResource by lazy {
      DrawableResource("drawable:info", setOf(
        ResourceItem(setOf(), "${MD}drawable/info.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_210_378_801)
internal val Res.drawable.instagram_logo: DrawableResource by lazy {
      DrawableResource("drawable:instagram_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/instagram_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-806_597_700)
internal val Res.drawable.intersect: DrawableResource by lazy {
      DrawableResource("drawable:intersect", setOf(
        ResourceItem(setOf(), "${MD}drawable/intersect.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(369_699_203)
internal val Res.drawable.intersect_three: DrawableResource by lazy {
      DrawableResource("drawable:intersect_three", setOf(
        ResourceItem(setOf(), "${MD}drawable/intersect_three.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_567_417_445)
internal val Res.drawable.intersection: DrawableResource by lazy {
      DrawableResource("drawable:intersection", setOf(
        ResourceItem(setOf(), "${MD}drawable/intersection.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_054_167_630)
internal val Res.drawable.invoice: DrawableResource by lazy {
      DrawableResource("drawable:invoice", setOf(
        ResourceItem(setOf(), "${MD}drawable/invoice.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_442_082_929)
internal val Res.drawable.island: DrawableResource by lazy {
      DrawableResource("drawable:island", setOf(
        ResourceItem(setOf(), "${MD}drawable/island.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_598_112_851)
internal val Res.drawable.jar: DrawableResource by lazy {
      DrawableResource("drawable:jar", setOf(
        ResourceItem(setOf(), "${MD}drawable/jar.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-251_821_859)
internal val Res.drawable.jar_label: DrawableResource by lazy {
      DrawableResource("drawable:jar_label", setOf(
        ResourceItem(setOf(), "${MD}drawable/jar_label.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_295_051_360)
internal val Res.drawable.jeep: DrawableResource by lazy {
      DrawableResource("drawable:jeep", setOf(
        ResourceItem(setOf(), "${MD}drawable/jeep.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(583_664_169)
internal val Res.drawable.joystick: DrawableResource by lazy {
      DrawableResource("drawable:joystick", setOf(
        ResourceItem(setOf(), "${MD}drawable/joystick.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(523_142_766)
internal val Res.drawable.kanban: DrawableResource by lazy {
      DrawableResource("drawable:kanban", setOf(
        ResourceItem(setOf(), "${MD}drawable/kanban.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_580_603_831)
internal val Res.drawable.key: DrawableResource by lazy {
      DrawableResource("drawable:key", setOf(
        ResourceItem(setOf(), "${MD}drawable/key.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-11_813_128)
internal val Res.drawable.key_return: DrawableResource by lazy {
      DrawableResource("drawable:key_return", setOf(
        ResourceItem(setOf(), "${MD}drawable/key_return.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_975_135_051)
internal val Res.drawable.keyboard: DrawableResource by lazy {
      DrawableResource("drawable:keyboard", setOf(
        ResourceItem(setOf(), "${MD}drawable/keyboard.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_132_859_374)
internal val Res.drawable.keyhole: DrawableResource by lazy {
      DrawableResource("drawable:keyhole", setOf(
        ResourceItem(setOf(), "${MD}drawable/keyhole.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_683_883_595)
internal val Res.drawable.knife: DrawableResource by lazy {
      DrawableResource("drawable:knife", setOf(
        ResourceItem(setOf(), "${MD}drawable/knife.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_532_704_830)
internal val Res.drawable.ladder: DrawableResource by lazy {
      DrawableResource("drawable:ladder", setOf(
        ResourceItem(setOf(), "${MD}drawable/ladder.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(72_253_032)
internal val Res.drawable.ladder_simple: DrawableResource by lazy {
      DrawableResource("drawable:ladder_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/ladder_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_328_780_658)
internal val Res.drawable.lamp: DrawableResource by lazy {
      DrawableResource("drawable:lamp", setOf(
        ResourceItem(setOf(), "${MD}drawable/lamp.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(591_294_093)
internal val Res.drawable.lamp_pendant: DrawableResource by lazy {
      DrawableResource("drawable:lamp_pendant", setOf(
        ResourceItem(setOf(), "${MD}drawable/lamp_pendant.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_281_444_933)
internal val Res.drawable.laptop: DrawableResource by lazy {
      DrawableResource("drawable:laptop", setOf(
        ResourceItem(setOf(), "${MD}drawable/laptop.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-852_945_260)
internal val Res.drawable.lasso: DrawableResource by lazy {
      DrawableResource("drawable:lasso", setOf(
        ResourceItem(setOf(), "${MD}drawable/lasso.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(749_399_454)
internal val Res.drawable.lastfm_logo: DrawableResource by lazy {
      DrawableResource("drawable:lastfm_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/lastfm_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_112_279_122)
internal val Res.drawable.layout: DrawableResource by lazy {
      DrawableResource("drawable:layout", setOf(
        ResourceItem(setOf(), "${MD}drawable/layout.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-427_712_831)
internal val Res.drawable.leaf: DrawableResource by lazy {
      DrawableResource("drawable:leaf", setOf(
        ResourceItem(setOf(), "${MD}drawable/leaf.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-241_092_254)
internal val Res.drawable.lectern: DrawableResource by lazy {
      DrawableResource("drawable:lectern", setOf(
        ResourceItem(setOf(), "${MD}drawable/lectern.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_548_831_132)
internal val Res.drawable.lego: DrawableResource by lazy {
      DrawableResource("drawable:lego", setOf(
        ResourceItem(setOf(), "${MD}drawable/lego.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(300_466_901)
internal val Res.drawable.lego_smiley: DrawableResource by lazy {
      DrawableResource("drawable:lego_smiley", setOf(
        ResourceItem(setOf(), "${MD}drawable/lego_smiley.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-459_652_916)
internal val Res.drawable.less_than: DrawableResource by lazy {
      DrawableResource("drawable:less_than", setOf(
        ResourceItem(setOf(), "${MD}drawable/less_than.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-643_847_831)
internal val Res.drawable.less_than_or_equal: DrawableResource by lazy {
      DrawableResource("drawable:less_than_or_equal", setOf(
        ResourceItem(setOf(), "${MD}drawable/less_than_or_equal.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-567_782_244)
internal val Res.drawable.letter_circle_h: DrawableResource by lazy {
      DrawableResource("drawable:letter_circle_h", setOf(
        ResourceItem(setOf(), "${MD}drawable/letter_circle_h.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_174_052_227)
internal val Res.drawable.letter_circle_p: DrawableResource by lazy {
      DrawableResource("drawable:letter_circle_p", setOf(
        ResourceItem(setOf(), "${MD}drawable/letter_circle_p.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(893_051_785)
internal val Res.drawable.letter_circle_v: DrawableResource by lazy {
      DrawableResource("drawable:letter_circle_v", setOf(
        ResourceItem(setOf(), "${MD}drawable/letter_circle_v.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(605_914_045)
internal val Res.drawable.lifebuoy: DrawableResource by lazy {
      DrawableResource("drawable:lifebuoy", setOf(
        ResourceItem(setOf(), "${MD}drawable/lifebuoy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-447_400_199)
internal val Res.drawable.lightbulb: DrawableResource by lazy {
      DrawableResource("drawable:lightbulb", setOf(
        ResourceItem(setOf(), "${MD}drawable/lightbulb.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-12_221_499)
internal val Res.drawable.lightbulb_filament: DrawableResource by lazy {
      DrawableResource("drawable:lightbulb_filament", setOf(
        ResourceItem(setOf(), "${MD}drawable/lightbulb_filament.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_816_508_558)
internal val Res.drawable.lighthouse: DrawableResource by lazy {
      DrawableResource("drawable:lighthouse", setOf(
        ResourceItem(setOf(), "${MD}drawable/lighthouse.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(568_128_706)
internal val Res.drawable.lightning: DrawableResource by lazy {
      DrawableResource("drawable:lightning", setOf(
        ResourceItem(setOf(), "${MD}drawable/lightning.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_633_768_867)
internal val Res.drawable.lightning_a: DrawableResource by lazy {
      DrawableResource("drawable:lightning_a", setOf(
        ResourceItem(setOf(), "${MD}drawable/lightning_a.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_269_212_357)
internal val Res.drawable.lightning_slash: DrawableResource by lazy {
      DrawableResource("drawable:lightning_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/lightning_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_991_215_610)
internal val Res.drawable.line_segment: DrawableResource by lazy {
      DrawableResource("drawable:line_segment", setOf(
        ResourceItem(setOf(), "${MD}drawable/line_segment.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_009_821_900)
internal val Res.drawable.line_segments: DrawableResource by lazy {
      DrawableResource("drawable:line_segments", setOf(
        ResourceItem(setOf(), "${MD}drawable/line_segments.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_145_200_389)
internal val Res.drawable.line_vertical: DrawableResource by lazy {
      DrawableResource("drawable:line_vertical", setOf(
        ResourceItem(setOf(), "${MD}drawable/line_vertical.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_958_730_463)
internal val Res.drawable.link: DrawableResource by lazy {
      DrawableResource("drawable:link", setOf(
        ResourceItem(setOf(), "${MD}drawable/link.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_588_039_497)
internal val Res.drawable.link_break: DrawableResource by lazy {
      DrawableResource("drawable:link_break", setOf(
        ResourceItem(setOf(), "${MD}drawable/link_break.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-948_261_119)
internal val Res.drawable.link_simple: DrawableResource by lazy {
      DrawableResource("drawable:link_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/link_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_431_302_963)
internal val Res.drawable.link_simple_break: DrawableResource by lazy {
      DrawableResource("drawable:link_simple_break", setOf(
        ResourceItem(setOf(), "${MD}drawable/link_simple_break.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_159_106_112)
internal val Res.drawable.link_simple_horizontal: DrawableResource by lazy {
      DrawableResource("drawable:link_simple_horizontal", setOf(
        ResourceItem(setOf(), "${MD}drawable/link_simple_horizontal.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-835_260_774)
internal val Res.drawable.link_simple_horizontal_break: DrawableResource by lazy {
      DrawableResource("drawable:link_simple_horizontal_break", setOf(
        ResourceItem(setOf(), "${MD}drawable/link_simple_horizontal_break.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-82_076_892)
internal val Res.drawable.linkedin_logo: DrawableResource by lazy {
      DrawableResource("drawable:linkedin_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/linkedin_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_406_549_393)
internal val Res.drawable.linktree_logo: DrawableResource by lazy {
      DrawableResource("drawable:linktree_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/linktree_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-738_047_879)
internal val Res.drawable.linux_logo: DrawableResource by lazy {
      DrawableResource("drawable:linux_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/linux_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_143_012_365)
internal val Res.drawable.list: DrawableResource by lazy {
      DrawableResource("drawable:list", setOf(
        ResourceItem(setOf(), "${MD}drawable/list.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-762_631_597)
internal val Res.drawable.list_bullets: DrawableResource by lazy {
      DrawableResource("drawable:list_bullets", setOf(
        ResourceItem(setOf(), "${MD}drawable/list_bullets.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_241_773_096)
internal val Res.drawable.list_checks: DrawableResource by lazy {
      DrawableResource("drawable:list_checks", setOf(
        ResourceItem(setOf(), "${MD}drawable/list_checks.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-443_378_795)
internal val Res.drawable.list_dashes: DrawableResource by lazy {
      DrawableResource("drawable:list_dashes", setOf(
        ResourceItem(setOf(), "${MD}drawable/list_dashes.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-318_597_104)
internal val Res.drawable.list_heart: DrawableResource by lazy {
      DrawableResource("drawable:list_heart", setOf(
        ResourceItem(setOf(), "${MD}drawable/list_heart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-987_506_326)
internal val Res.drawable.list_magnifying_glass: DrawableResource by lazy {
      DrawableResource("drawable:list_magnifying_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/list_magnifying_glass.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(580_491_799)
internal val Res.drawable.list_numbers: DrawableResource by lazy {
      DrawableResource("drawable:list_numbers", setOf(
        ResourceItem(setOf(), "${MD}drawable/list_numbers.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(969_281_571)
internal val Res.drawable.list_plus: DrawableResource by lazy {
      DrawableResource("drawable:list_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/list_plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_413_903_715)
internal val Res.drawable.list_star: DrawableResource by lazy {
      DrawableResource("drawable:list_star", setOf(
        ResourceItem(setOf(), "${MD}drawable/list_star.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_848_590_093)
internal val Res.drawable.lock: DrawableResource by lazy {
      DrawableResource("drawable:lock", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-473_987_938)
internal val Res.drawable.lock_key_open: DrawableResource by lazy {
      DrawableResource("drawable:lock_key_open", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock_key_open.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-252_652_386)
internal val Res.drawable.lock_laminated: DrawableResource by lazy {
      DrawableResource("drawable:lock_laminated", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock_laminated.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(26_450_262)
internal val Res.drawable.lock_laminated_open: DrawableResource by lazy {
      DrawableResource("drawable:lock_laminated_open", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock_laminated_open.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_084_373_343)
internal val Res.drawable.lock_open: DrawableResource by lazy {
      DrawableResource("drawable:lock_open", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock_open.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_506_874_965)
internal val Res.drawable.lock_simple: DrawableResource by lazy {
      DrawableResource("drawable:lock_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-101_688_087)
internal val Res.drawable.lock_simple_open: DrawableResource by lazy {
      DrawableResource("drawable:lock_simple_open", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock_simple_open.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-229_958_463)
internal val Res.drawable.lockers: DrawableResource by lazy {
      DrawableResource("drawable:lockers", setOf(
        ResourceItem(setOf(), "${MD}drawable/lockers.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_025_309_526)
internal val Res.drawable.log: DrawableResource by lazy {
      DrawableResource("drawable:log", setOf(
        ResourceItem(setOf(), "${MD}drawable/log.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_538_182)
internal val Res.drawable.logo_horizontal_dark: DrawableResource by lazy {
      DrawableResource("drawable:logo_horizontal_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_horizontal_dark.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(421_326_840)
internal val Res.drawable.logo_horizontal_light: DrawableResource by lazy {
      DrawableResource("drawable:logo_horizontal_light", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_horizontal_light.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_257_897_378)
internal val Res.drawable.logo_vertical_dark: DrawableResource by lazy {
      DrawableResource("drawable:logo_vertical_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_vertical_dark.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_772_830_544)
internal val Res.drawable.logo_vertical_light: DrawableResource by lazy {
      DrawableResource("drawable:logo_vertical_light", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_vertical_light.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-520_159_123)
internal val Res.drawable.magic_wand: DrawableResource by lazy {
      DrawableResource("drawable:magic_wand", setOf(
        ResourceItem(setOf(), "${MD}drawable/magic_wand.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(346_585_281)
internal val Res.drawable.magnet: DrawableResource by lazy {
      DrawableResource("drawable:magnet", setOf(
        ResourceItem(setOf(), "${MD}drawable/magnet.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(605_306_730)
internal val Res.drawable.magnet_straight: DrawableResource by lazy {
      DrawableResource("drawable:magnet_straight", setOf(
        ResourceItem(setOf(), "${MD}drawable/magnet_straight.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_453_362_219)
internal val Res.drawable.magnifying_glass: DrawableResource by lazy {
      DrawableResource("drawable:magnifying_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/magnifying_glass.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(286_820_164)
internal val Res.drawable.magnifying_glass_minus: DrawableResource by lazy {
      DrawableResource("drawable:magnifying_glass_minus", setOf(
        ResourceItem(setOf(), "${MD}drawable/magnifying_glass_minus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_113_009_613)
internal val Res.drawable.magnifying_glass_plus: DrawableResource by lazy {
      DrawableResource("drawable:magnifying_glass_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/magnifying_glass_plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(718_649_893)
internal val Res.drawable.mailbox: DrawableResource by lazy {
      DrawableResource("drawable:mailbox", setOf(
        ResourceItem(setOf(), "${MD}drawable/mailbox.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_383_745_316)
internal val Res.drawable.map: DrawableResource by lazy {
      DrawableResource("drawable:map", setOf(
        ResourceItem(setOf(), "${MD}drawable/map.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_907_781_093)
internal val Res.drawable.map_pin_area: DrawableResource by lazy {
      DrawableResource("drawable:map_pin_area", setOf(
        ResourceItem(setOf(), "${MD}drawable/map_pin_area.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_083_705_883)
internal val Res.drawable.map_pin_line: DrawableResource by lazy {
      DrawableResource("drawable:map_pin_line", setOf(
        ResourceItem(setOf(), "${MD}drawable/map_pin_line.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_692_433_913)
internal val Res.drawable.map_pin_plus: DrawableResource by lazy {
      DrawableResource("drawable:map_pin_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/map_pin_plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_254_160_901)
internal val Res.drawable.map_pin_simple: DrawableResource by lazy {
      DrawableResource("drawable:map_pin_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/map_pin_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_880_155_739)
internal val Res.drawable.map_pin_simple_area: DrawableResource by lazy {
      DrawableResource("drawable:map_pin_simple_area", setOf(
        ResourceItem(setOf(), "${MD}drawable/map_pin_simple_area.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable6Resources(map: MutableMap<String, DrawableResource>) {
  map.put("hourglass_simple_medium", Res.drawable.hourglass_simple_medium)
  map.put("house", Res.drawable.house)
  map.put("house_line", Res.drawable.house_line)
  map.put("house_simple", Res.drawable.house_simple)
  map.put("hurricane", Res.drawable.hurricane)
  map.put("ice_cream", Res.drawable.ice_cream)
  map.put("identification_badge", Res.drawable.identification_badge)
  map.put("identification_card", Res.drawable.identification_card)
  map.put("image", Res.drawable.image)
  map.put("image_broken", Res.drawable.image_broken)
  map.put("images", Res.drawable.images)
  map.put("infinity", Res.drawable.infinity)
  map.put("info", Res.drawable.info)
  map.put("instagram_logo", Res.drawable.instagram_logo)
  map.put("intersect", Res.drawable.intersect)
  map.put("intersect_three", Res.drawable.intersect_three)
  map.put("intersection", Res.drawable.intersection)
  map.put("invoice", Res.drawable.invoice)
  map.put("island", Res.drawable.island)
  map.put("jar", Res.drawable.jar)
  map.put("jar_label", Res.drawable.jar_label)
  map.put("jeep", Res.drawable.jeep)
  map.put("joystick", Res.drawable.joystick)
  map.put("kanban", Res.drawable.kanban)
  map.put("key", Res.drawable.key)
  map.put("key_return", Res.drawable.key_return)
  map.put("keyboard", Res.drawable.keyboard)
  map.put("keyhole", Res.drawable.keyhole)
  map.put("knife", Res.drawable.knife)
  map.put("ladder", Res.drawable.ladder)
  map.put("ladder_simple", Res.drawable.ladder_simple)
  map.put("lamp", Res.drawable.lamp)
  map.put("lamp_pendant", Res.drawable.lamp_pendant)
  map.put("laptop", Res.drawable.laptop)
  map.put("lasso", Res.drawable.lasso)
  map.put("lastfm_logo", Res.drawable.lastfm_logo)
  map.put("layout", Res.drawable.layout)
  map.put("leaf", Res.drawable.leaf)
  map.put("lectern", Res.drawable.lectern)
  map.put("lego", Res.drawable.lego)
  map.put("lego_smiley", Res.drawable.lego_smiley)
  map.put("less_than", Res.drawable.less_than)
  map.put("less_than_or_equal", Res.drawable.less_than_or_equal)
  map.put("letter_circle_h", Res.drawable.letter_circle_h)
  map.put("letter_circle_p", Res.drawable.letter_circle_p)
  map.put("letter_circle_v", Res.drawable.letter_circle_v)
  map.put("lifebuoy", Res.drawable.lifebuoy)
  map.put("lightbulb", Res.drawable.lightbulb)
  map.put("lightbulb_filament", Res.drawable.lightbulb_filament)
  map.put("lighthouse", Res.drawable.lighthouse)
  map.put("lightning", Res.drawable.lightning)
  map.put("lightning_a", Res.drawable.lightning_a)
  map.put("lightning_slash", Res.drawable.lightning_slash)
  map.put("line_segment", Res.drawable.line_segment)
  map.put("line_segments", Res.drawable.line_segments)
  map.put("line_vertical", Res.drawable.line_vertical)
  map.put("link", Res.drawable.link)
  map.put("link_break", Res.drawable.link_break)
  map.put("link_simple", Res.drawable.link_simple)
  map.put("link_simple_break", Res.drawable.link_simple_break)
  map.put("link_simple_horizontal", Res.drawable.link_simple_horizontal)
  map.put("link_simple_horizontal_break", Res.drawable.link_simple_horizontal_break)
  map.put("linkedin_logo", Res.drawable.linkedin_logo)
  map.put("linktree_logo", Res.drawable.linktree_logo)
  map.put("linux_logo", Res.drawable.linux_logo)
  map.put("list", Res.drawable.list)
  map.put("list_bullets", Res.drawable.list_bullets)
  map.put("list_checks", Res.drawable.list_checks)
  map.put("list_dashes", Res.drawable.list_dashes)
  map.put("list_heart", Res.drawable.list_heart)
  map.put("list_magnifying_glass", Res.drawable.list_magnifying_glass)
  map.put("list_numbers", Res.drawable.list_numbers)
  map.put("list_plus", Res.drawable.list_plus)
  map.put("list_star", Res.drawable.list_star)
  map.put("lock", Res.drawable.lock)
  map.put("lock_key_open", Res.drawable.lock_key_open)
  map.put("lock_laminated", Res.drawable.lock_laminated)
  map.put("lock_laminated_open", Res.drawable.lock_laminated_open)
  map.put("lock_open", Res.drawable.lock_open)
  map.put("lock_simple", Res.drawable.lock_simple)
  map.put("lock_simple_open", Res.drawable.lock_simple_open)
  map.put("lockers", Res.drawable.lockers)
  map.put("log", Res.drawable.log)
  map.put("logo_horizontal_dark", Res.drawable.logo_horizontal_dark)
  map.put("logo_horizontal_light", Res.drawable.logo_horizontal_light)
  map.put("logo_vertical_dark", Res.drawable.logo_vertical_dark)
  map.put("logo_vertical_light", Res.drawable.logo_vertical_light)
  map.put("magic_wand", Res.drawable.magic_wand)
  map.put("magnet", Res.drawable.magnet)
  map.put("magnet_straight", Res.drawable.magnet_straight)
  map.put("magnifying_glass", Res.drawable.magnifying_glass)
  map.put("magnifying_glass_minus", Res.drawable.magnifying_glass_minus)
  map.put("magnifying_glass_plus", Res.drawable.magnifying_glass_plus)
  map.put("mailbox", Res.drawable.mailbox)
  map.put("map", Res.drawable.map)
  map.put("map_pin_area", Res.drawable.map_pin_area)
  map.put("map_pin_line", Res.drawable.map_pin_line)
  map.put("map_pin_plus", Res.drawable.map_pin_plus)
  map.put("map_pin_simple", Res.drawable.map_pin_simple)
  map.put("map_pin_simple_area", Res.drawable.map_pin_simple_area)
}
